import React from 'react'
import { Box, Typography } from '@mui/material'
import { NAVY, BORDER, WHITE, LIGHT_BG } from '../../../styles/foundation/colors'
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography'

/**
 * Shared card wrapper for order detail page sections.
 * Renders a rounded card with a header bar and content area.
 *
 * @param {string} title — section heading
 * @param {React.ReactNode} [action] — optional right-side action (e.g. a button)
 * @param {React.ReactNode} children — card body
 */
export default function SectionCard({ title, action, children, sx: sxOverride }) {
  return (
    <Box
      sx={{
        borderRadius: '14px',
        border: `1px solid ${BORDER}`,
        bgcolor: WHITE,
        mb: 2,
        overflow: 'hidden',
        ...sxOverride,
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 1.25,
          borderBottom: `1px solid ${BORDER}`,
          bgcolor: LIGHT_BG,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: NAVY }}>
          {title}
        </Typography>
        {action}
      </Box>
      <Box sx={{ px: 2.5, py: 1.5 }}>{children}</Box>
    </Box>
  )
}
